<template>
  <div id="sidebar-left">
    <slot name="sidebar-left"></slot>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'

export default {
  name: "SidebarLeft",
  props: {},
  components: {},
  mixins: [
    store,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
#sidebar-left {
  width: 400px;
  min-width: 400px;
  background: #383838;
  border-right: 1px solid #595959;

  display: flex;
  flex-direction: column;

  .sidebar-top {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .sidebar-bot {
    background: #272727;
    border-top: 1px solid #595959;
  }
}
</style>
